Controller.$inject = [];

function Controller() {
}

export function HuiPopoverFooter() {
    return {
        restrict: 'E',
        scope: {},
        transclude: true,
        controller: Controller,
        controllerAs: '$huiPopoverFooterCtrl',
        template: `
            <div class="hui-popover-footer">
                <ng-transclude></ng-transclude>
            </div>
        `
    };
} 